import React, { useState, useEffect } from 'react';
import { ArrowRight, MessageSquare, Scale, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
// Import background image
import backgroundImage from '../../assets/images/main.jpg';

const HeroSection = () => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    
    // WhatsApp phone number - replace with your actual number
    const phoneNumber = '923329754400';
    const message = encodeURIComponent('I am here for free consultation');
    
    useEffect(() => {
        // Trigger animation after component mounts
        setIsVisible(true);
    }, []);

    const handleFreeInquiry = () => {
        // WhatsApp URL with pre-filled message - keeping original functionality
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
        // Open WhatsApp in a new tab
        window.open(whatsappUrl, '_blank');
    };

    const handleViewServices = () => {
        // Navigate to services page
        navigate('/services');
    };

    // Key benefits data
    const benefits = [
        {
            icon: <Scale className="w-6 h-6" />,
            title: "Expert Legal Representation",
            description: "Our experienced attorneys fight tirelessly for your rights",
        },
        {
            icon: <MessageSquare className="w-6 h-6" />,
            title: "Free Consultation",
            description: "Get professional legal advice with no obligations",
        },
        {
            icon: <Shield className="w-6 h-6" />,
            title: "Results Guaranteed",
            description: "We're committed to securing the best outcome for your case",
        }
    ];

    return (
        <div className="relative min-h-screen">
            {/* Background Image with Overlay */}
            <div 
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${backgroundImage})` }}
            >
                {/* Gradient overlay for more professional look */}
                <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/70"></div>
            </div>

            {/* Content */}
            <div className="relative z-10 container mx-auto px-4 min-h-screen flex flex-col justify-center pt-16">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                    <div className={`transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                        <div className="inline-block bg-indigo-600 px-4 py-1 rounded-md text-white text-sm font-medium mb-4">
                            TRUSTED LEGAL ADVISORS
                        </div>
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                            We Never Stop <span className="text-indigo-400">Until We Win</span>
                        </h1>
                        <p className="text-lg text-gray-300 mb-8 max-w-xl">
                            Our firm delivers unmatched legal expertise with a focus on results. 
                            We anticipate challenges, mitigate risks, and protect our clients' interests at every turn.
                        </p>
                        
                        <div className="flex flex-col sm:flex-row gap-4 mb-8">
                            <button 
                                onClick={handleFreeInquiry}
                                className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-4 rounded-md flex items-center justify-center font-medium transition-all transform hover:scale-105 shadow-lg"
                            >
                                FREE INQUIRY
                                <ArrowRight className="ml-2 w-5 h-5" />
                            </button>
                            <button 
                                onClick={handleViewServices}
                                className="border-2 border-white text-white px-8 py-4 rounded-md hover:bg-white hover:text-gray-900 transition-all transform hover:scale-105 font-medium"
                            >
                                OUR SERVICES
                            </button>
                        </div>
                    </div>
                    
                    {/* Key benefits cards */}
                    <div className={`transition-all duration-1000 delay-300 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                        <div className="bg-black/30 backdrop-blur-sm p-6 rounded-xl border border-gray-700">
                            {benefits.map((benefit, index) => (
                                <div 
                                    key={index} 
                                    className={`flex items-start gap-4 p-4 ${
                                        index < benefits.length - 1 ? 'border-b border-gray-700 mb-4' : ''
                                    }`}
                                >
                                    <div className="bg-indigo-600/20 p-3 rounded-lg text-indigo-400">
                                        {benefit.icon}
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-white text-lg mb-1">{benefit.title}</h3>
                                        <p className="text-gray-400">{benefit.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Decorative element */}
            <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black to-transparent z-10"></div>
        </div>
    );
};

export default HeroSection;